module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-canvas"
  }, [_c('canvas', {
    ref: "canvasRef",
    attrs: {
      "id": "canvasNode",
      "width": "220px",
      "height": "72px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c4e300","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/components/previewCanvas.vue
// module id = 665
// module chunks = 1